import React from "react";

type StatusType = "ready" | "success" | "error";

interface StatusDisplayProps {
  status: StatusType | null;
  text?: string;
  className?: string;
}

export const StatusDisplay: React.FC<StatusDisplayProps> = ({
  status,
  text,
  className = "",
}) => {
  const bgColor = {
    ready: "bg-gray-200 text-gray-500",
    success: "bg-green-500 text-white",
    error: "bg-red-500 text-white",
    null: "bg-gray-200 text-gray-500",
  };

  const displayText =
    text ||
    {
      ready: "READY TO SCAN",
      success: "PASS",
      error: "FAIL",
      null: "READY TO SCAN",
    }[status || "null"];

  return (
    <div
      className={`w-full max-w-2xl h-60 flex items-center justify-center rounded-lg shadow-lg text-6xl font-bold ${
        bgColor[status || "null"]
      } ${className}`}
    >
      {displayText}
    </div>
  );
};
